import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { EntitySelectPageContext } from "./EntitySelectPageContext";

export const useEntitiesListProvider = () => {
  const context = useContext(EntitySelectPageContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useEntitiesListProvider",
      "EntityListProviderContext"
    );
  }

  return context;
};
